import { CoverPageRouter } from '@rikstv/play-common/src/components/coverPage/CoverPageRouter';
import { KnownExternalServiceId } from '@rikstv/play-common/src/forces/externalService/externalServiceIds';

import { rtvConfig } from '../../../config';
import { PlayerNoAccessDialog } from '../../../domain/user/containers/PlayerNoAccessDialog';
import { PlayerSignupDialog } from '../../../domain/user/containers/PlayerSignupDialog';
import { useExternalServiceStore } from '../../../domain/user/externalServiceStore';

const getActivationStatus = (id: KnownExternalServiceId) => {
  const activated = useExternalServiceStore.getState().isActivated(id);
  return {
    activated,
    activationPageUrl: !activated ? rtvConfig.myPageUrl : undefined,
  };
};

export const CoverPageFactory = () => (
  <CoverPageRouter
    noAccessDialogue={PlayerNoAccessDialog}
    signupDialogue={PlayerSignupDialog}
    getExternalServiceStatus={getActivationStatus}
  />
);
